import { gql } from '@apollo/client';

export const ALL_INSIGHT_TAGS = gql`
  query allInsightTags($input: getTagInput!) {
    InsightTag: allInsightTags(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
